import { defaultPlatformUrl } from './axios.config'

// 英文/国际化：新协作者接口
export const collaboratorAddApi = defaultPlatformUrl + '/website/collaborator/add'

// 中文：官网原留言接口
export const consultLegacyApi = 'https://www.din-job.com/business/insertConsult'
